<!-- TODO(core): the theme's fullscreen close button is 1.5rem shorter than Taiga's, which the viewer's top margin is sized for. -->
<tui-pdf-viewer class="[tui-root:not(.\_mobile)_&]:-mt-18!">
  <h2 tuiTitle>{{ title }}</h2>
  <iframe data-testid="pdf" [src]="url" [title]="title"></iframe>
</tui-pdf-viewer>
